import { basicInitialState } from '../_utils/basicInitialState';
import { TCompanyState } from './company';

export const companyInitialState: TCompanyState = {
  ...basicInitialState,
  company: null,
  fields: {},
  isTouched: false
};
